import Vue from 'vue'
import {directive as Clickaway} from 'vue-clickaway'

Vue.directive('clickaway', Clickaway)